<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-progress-circular
          v-if="loading"
          indeterminate
          class="primary--text"
          :width="7"
          :size="10"
        />
      </v-flex>
    </v-layout>
    <v-layout
      v-if="paginatedBookmarks.length == 0 && !loading"
      row
    >
      <v-flex xs12>
        <v-card
          class="pa-2"
          elevation="1"
          target="_blank"
          href="http://brocheballetonline.com/technique-library"
        >
          <v-row>
            <v-col
              v-if="$vuetify.breakpoint.mdAndUp"
              l="2"
              md="3"
            >
              <v-img
                class="ma-5"
                :aspect-ratio="16/9"
                src="https://storage.googleapis.com/video-storage.brocheballet.com/Start%20Bookmarking.png"
                contain
              />
            </v-col>
            <v-col>
              <p class="custom-title pt-3">Get started bookmarking videos!</p>
              <p>Visit your favorite video in the Technique Library and look for the "Bookmark" button at the top of the page.</p>
            </v-col>
          </v-row>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="paginatedBookmarks.length > 0 && $vuetify.breakpoint.smAndUp"
      row
      wrap
    >
      <v-flex
        v-for="video in paginatedBookmarks"
        :key="video.bookmarkId"
        xs12
      >
        <v-card
          class="pa-2"
          :href="video.pageURL"
          target="_blank"
          elevation="1"
        >
          <v-row>
            <v-col
              l="2"
              md="3"
            >
              <v-img
                class="ma-5"
                :aspect-ratio="16/9"
                :src="video.videoThumbURL"
                contain
              />
            </v-col>
            <v-col>
              <p class="custom-title pt-3">{{ video.title }}</p>
              <p>Bookmark added {{ formatDateAdded(video) }}</p>
              <p class="pt-3"><v-icon dense>mdi-play</v-icon> Watch now</p>
            </v-col>
          </v-row>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="paginatedBookmarks.length > 0 && $vuetify.breakpoint.xs"
      row
      wrap
    >
      <v-flex
        v-for="video in paginatedBookmarks"
        :key="video.bookmarkId"
        xs12
      >
        <v-card
          class="pa-2"
          :href="video.pageURL"
          target="_blank"
          elevation="1"
        >
          <v-row>
            <v-img
              class="ma-5"
              :aspect-ratio="16/9"
              :src="video.videoThumbURL"
              contain
            />
            <p class="custom-title">{{ video.title }}</p>
            <p>Bookmark added {{ formatDateAdded(video) }}</p>
          </v-row>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="paginatedBookmarks.length > 1"
      row
    >
      <v-flex xs12>
        <v-pagination
          v-if="paginationLength > 1"
          v-model="page"
          :length="paginationLength"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import moment from 'moment-timezone'
  export default {
    props: ['id'],
    data () {
      return {
        page: 1,
        itemsPerPage: 9,
        maxItems: 0
      }
    },
    computed: {
      bookmarks () {
        var bookmarks = this.$store.getters.loadedBookmarksForCurrentDancer
        return bookmarks.sort((bookmarkA, bookmarkB) => {
          if (bookmarkA.dateAdded === undefined) {
            return -1
          }
          if (bookmarkB.dateAdded === undefined) {
            return 1
          }
          return moment.unix(bookmarkA.dateAdded).isBefore(moment.unix(bookmarkB.dateAdded)) ? 1 : -1
        })
      },
      paginatedBookmarks () {
        var startIndex = (this.page - 1) * this.itemsPerPage
        var endIndex = (this.page) * this.itemsPerPage
        var bookmarks = this.bookmarks.slice(startIndex, endIndex)
        if (this.maxItems > 0) {
          return bookmarks.slice(0, this.maxItems)
        } else {
          return bookmarks
        }
      },
      paginationLength () {
        return Math.ceil(this.bookmarks.length / this.itemsPerPage)
      },
      loading () {
        return this.$store.getters.loading
      }
    },
    created () {
      this.$store.dispatch('logDancerInByMemberstackID', this.id).then(() => {
        this.$store.dispatch('loadBookmarkedVideosForCurrentDancer')
      })
      if (this.$route.query.embed) {
        this.$store.commit('setLayout', 'embed-layout')
      }
      if (this.$route.query.limit) {
        this.maxItems = this.$route.query.limit
      }
    },
    methods: {
      formatDateAdded (video) {
        return moment(parseInt(video.dateAdded)).format('MMMM D, YYYY')
      }
    }
  }
</script>

<style>
  p {
    font-size:14px;
    font-family: "Fanwood Text";
    justify-content: left;
    color:rgba(40,26,23,.6);
    font-weight:400;
    padding: 0 20px;
    margin-bottom:5px !important;
  }

  p.custom-title {
    font-size:20px;
  }
</style>
